<template>
    <div class="recommend" v-if="book">
        <div class="recommend-title">推荐教材</div>
        <div class="recommend-book">
            <div class="book-cover">
                <img :src="book.cover">
                <div class="book-shadow" :class="{ 'dark-cover': book.isDarkCover }"></div>
            </div>
            <div class="book-info-box">
                <div class="book-info">
                    <div class="book-name" :class="{ 'ellipsis': phoneMode, 'ellipsis2': !phoneMode }">{{ book.name }}
                    </div>
                    <div class="book-sub-name" v-if="book.chief_editor_name">{{ book.chief_editor_name }}</div>
                    <div class="book-sub-name" v-if="book.isbn">{{ book.isbn }}</div>
                    <div class="book-price">￥{{ book.price }}</div>
                    <div class="book-introduce">
                        <!-- <div class="book-introduce-title">内容简介</div> -->
                        <div class="book-introduce-content ellipsis-x"
                            :class="{ 'line2': phoneMode, 'line3': !phoneMode }" v-html="introduce || '<p>暂无简介</p>'">
                        </div>
                    </div>
                </div>
                <a-button class="book-button" type="primary" @click="routerCourse(book)">立即查看</a-button>
            </div>
            <div class="book-hanlder">
                <a-tooltip title="上一本">
                    <div class="hanlder-item" @click="bookSwich(-1)">
                        <svg class="icon">
                            <use xlink:href="#icon-last"></use>
                        </svg>
                    </div>
                </a-tooltip>
                <a-tooltip title="下一本">
                    <div class="hanlder-item" @click="bookSwich(1)">
                        <svg class="icon">
                            <use xlink:href="#icon-next"></use>
                        </svg>
                    </div>
                </a-tooltip>
            </div>
        </div>
    </div>
</template>
<script setup>

import { computed, onMounted, ref } from 'vue'
import store from "@/store";
import router from '@/router'


const props = defineProps({
    storeBooks: {
        type: Object
    }
})

const book = computed(() => props.storeBooks[bookIndex.value])
const phoneMode = computed(() => store.state.phoneMode)

const bookIndex = ref(0)
const introduce = ref('')

onMounted(() => {
    if (book.value) introduceSet();
})

function introduceSet() {
    introduce.value = book.value.extension_info?.introduce
        ?.replace(/style\s*?=\s*?['"][^'"]*?['"]/gi, '') // 移除所有style属性
        ?.replace(/<font[^>]*>/gi, '')?.replace(/<\/font>/gi, '') // 移除font标签
        ?.replace(/<span[^>]*>/gi, '')?.replace(/<\/span>/gi, ''); // 移除span标签
}

//切换
function bookSwich(index) {
    const { length } = props.storeBooks;
    if (index === 1) {
        bookIndex.value = bookIndex.value === length - 1 ? 0 : bookIndex.value + 1;
    }
    else {
        bookIndex.value = bookIndex.value === 0 ? length - 1 : bookIndex.value - 1;
    }
    introduceSet();
}

//跳转
function routerCourse(item) {
    const { isPaid } = item;
    if (isPaid) {
        routerStudy(item);
    }
    else {
        routerInfo(item);
    }
}

//跳转详情
function routerInfo(item) {
    $("#content").css("overflow-y", "auto");
    $("#content").css("padding-right", "0px");
    router.push(`/course-info/${item.pk_store_book_id}`);
}

//学习
function routerStudy(item) {
    const { pk_store_book_id } = item;
    let url = `/bookReader/${pk_store_book_id}`;
    window.open(url)
}


</script>

<style lang="scss" scoped>
.recommend {
    padding: 50px 20px;
    max-width: 1300px;
    margin: 0 auto;
    color: #333333;
    margin-bottom: 100px;

    .recommend-title {
        font-size: 30px;
        margin-bottom: 30px;
        color: #ffffff;
    }

    .recommend-book {
        border-radius: 7px;
        padding: 40px 80px;
        height: 410px;
        width: 100%;
        box-shadow: var(--box-shadow);
        background: var(--background-opacity-top);
        display: flex;
        align-items: center;
        justify-content: space-between;

        .book-cover {
            width: 220px;
            height: 100%;
            overflow: hidden;
            position: relative;
            transition: all .3s ease;
            box-shadow: var(--box-shadow);
            border-radius: 10px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .book-info-box {
            width: calc(100% - 300px);
            padding-left: 100px;
            height: 100%;

            .book-info {
                height: calc(100% - 32px);
                font-size: 18px;
                color: #ffffff;

                >div {
                    &:not(:last-child) {
                        margin-bottom: 10px;
                    }
                }

                .book-name {
                    font-size: 30px;
                    margin-bottom: 20px;
                    font-weight: bold;
                }

                .book-price {
                    color: var(--primary-color);
                }

                .book-introduce {
                    margin-top: 30px;

                    .book-introduce-title {
                        font-size: 17px;
                        font-weight: bold;
                    }

                    .book-introduce-content {
                        font-size: 17px;
                        color: #ffffff !important;

                        :deep(p, h1, h2, h3, h4, h5, h6) {
                            text-indent: 2em;
                            margin-top: 5px;
                            margin-bottom: 0;
                            font-size: 17px;
                            color: #ffffff !important;
                        }
                    }
                }
            }
        }

        .book-hanlder {
            .hanlder-item {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                background: #cccccccf;
                margin: 20px 0;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                user-select: none;
                transition: all .3s ease;

                &:hover {
                    .icon {
                        color: var(--primary-color);
                    }
                }

                .icon {
                    font-size: 24px;
                    color: #080808;
                }
            }
        }
    }
}

#content {
    &.phone-mode {
        .recommend {
            padding: 0;
            padding-top: 20px;
            max-width: 100%;

            .recommend-title {
                font-size: 24px;
                margin: 20px;
            }

            .recommend-book {
                padding: 10px;
                height: 240px;
                width: calc(100% - 10px);
                margin: 0 auto;

                .book-cover {
                    width: 120px;
                    height: 180px;
                }

                .book-info-box {
                    width: calc(100% - 150px);
                    padding-left: 20px;

                    .book-info {
                        font-size: 14px;

                        >div {
                            &:not(:last-child) {
                                margin-bottom: 5px;
                            }
                        }

                        .book-name {
                            font-size: 20px;
                            margin-bottom: 10px;
                        }

                        .book-introduce {
                            margin-top: 0;

                            .book-introduce-title {
                                font-size: 14px;
                            }

                            .book-introduce-content {
                                :deep(p) {
                                    font-size: 12px;
                                }
                            }
                        }
                    }
                }

                .book-hanlder {
                    .hanlder-item {
                        width: 24px;
                        height: 24px;
                        margin: 10px 0;

                        .icon {
                            font-size: 18px;
                        }

                    }
                }
            }
        }
    }
}
</style>